export default __webpack_public_path__ + "static/media/logo_agin_N.8802e6b8.png";